import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@app/authentication/services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
    constructor(private router: Router, private authenticationService: AuthenticationService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const bearerToken = this.authenticationService.userValue;
        if (!bearerToken) {
            void this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }

        // If route defines allowed roles, check the user's role against them
        const allowedRoles = route.data.roles as string[] | undefined;
        if (allowedRoles && allowedRoles.length > 0) {
            const userRole = this.authenticationService.getLoggedInRole();
            if (!allowedRoles.includes(userRole)) {
                void this.router.navigate(['/dashboard']);
                return false;
            }
        }

        return true;
    }
}
